import React, { useState, useEffect,useRef } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap";
import SelectBoxSearch from "../../../common/SelectBoxSearch";
import { tasks } from "../../../../datas/tasks";
import Multiselect from 'multiselect-react-dropdown';
import moment from "moment";
import api from "../../../../apis/api";
import Notifications from "../../../../components/common/Notifications";
// ======================================= Add Edit Form-2 ===========================================..
const AddEditForm = ({ toggleAddEditFormClose,handelAddTaskByLead, selectedTask ,employee ,selectedEmp,selProjectId,category}) => {
  const [task, setTask] = useState(null);
  const [estimateHours, setEstimatedHours] = useState(null);
  const [description, setDescription] = useState(null);
  const [employeeTimesheetId,setemployeeTimesheetId] = useState(0);
  const [dueDate, setDueDate] = useState(new Date());
  const [taskFollowers, setTaskFollowers] = useState([]);
  const [formValidationState, setFormValidationState] = useState({});
  const [option,setOption]=useState([]);
  const [SelectedOption,setSelectedOption]=useState([]);
  const [error, setError] = useState(null);
  const [isopenpopup,setisopenpopup]=useState(false);
  const [isopenpopupSuccess,setisopenpopupSuccess]=useState(false);

  const callValidation = useRef(false);
  var loginUser = JSON.parse(localStorage.getItem("user"));
 let empoptions = employee
  .filter(el => el.isActive)
  .map(el => ({
    value: el.employeeId,
    label: el.employeeName
  }));
  useEffect(() => {

   
    if (selectedTask) {

      setTask(selectedTask.issueTitle);
      setEstimatedHours(selectedTask.estimatedHour);
      setDescription(selectedTask.description);
      setDueDate(new Date(selectedTask.dueDate));
      setemployeeTimesheetId(selectedTask.employeeTimeSheetId);

      employee.map((emp) =>{
        if(selectedTask.employeeIds.split(',').indexOf(String(emp.employeeId)) > -1 ) {
          let arrayfol={
            value:emp.employeeId,
            label:emp.employeeName,
          };
          setOption((prevState) => prevState.concat(arrayfol));
          setSelectedOption((prevState) => prevState.concat(emp.employeeId))
       }
  
      })
      //   setDueDate(dueDate);
    } else {
      setTask(null);
      setEstimatedHours(null);
      setDescription(null);
      // setDueDate(null);
    }
  }, [selectedTask]);

  //   Functions.
  // const { formValidation, isFormValid } = useFormValidation(
  //   formValidationState
  // );

  // useEffect(() => {
  //   // calls when form submited`
  //   callValidation.current && callBackAfterValidation();
  // }, [formValidation]);


  const handleTaskFollowers = (e) => {
    let selectedEmployee = (employee).filter(
      (el) => el.employeeId === e
    );
    let arrayfol={
      value:selectedEmployee[0].employeeId,
      label:selectedEmployee[0].employeeName,
    };

    // setOption({employeeId:selectedEmployee[0].employeeId,employeeName:selectedEmployee[0].employeeName} );
    setOption((prevState) => prevState.concat(arrayfol));
    setSelectedOption((prevState) => prevState.concat(e))
  };
  const formValidationOnSubmitAdd = (e) => {
    e.preventDefault();
    let formValidationList = {
      // key name should be same as the input field name.
      task: {
        required: true,
        isValid: true,
        value: task,
        errorMessage: "",
      },
      // designation: {
      //   required: true,
      //   isValid: true,
      //   value:String(selectedDesig),
      //   errorMessage: "",
      // },
      // description: {
      //   required: true,
      //   isValid: true,
      //   value: attributeDescription,
      //   errorMessage: "",
      // },
    };
    setFormValidationState(formValidationList); //this set call the custom hook useFormValidation.
    callValidation.current = true;
  };
  const handelsubmit =() =>{
   
    
      let formdata={
        employeeTimesheetId:employeeTimesheetId,
        issueTitle : task,
        dueDate : dueDate,
        estimatedHour: estimateHours,
        description : description,
        employeeIds : String(SelectedOption),
        projectID:selProjectId,
        createdBy :loginUser.EmployeeId,
        timeSheetStatus:category==="New" ? 1 :(category === "In Progress" ? 2 : (category === "Completed" ? 3 : 4))
      }
      let splitemp=String(SelectedOption);
      const items = splitemp.split(',');
      let checkusernameStatus=[];
      const listItems = [];
      const fetchapi=async () =>{ 
        for (let i = 0; i < items.length; i++) {
          const res=await api.dailytask().CheckExistingTaskName(formdata.issueTitle,formdata.projectID,parseInt(items[i].trim()));
          checkusernameStatus.push(res.data);
        }
        if (checkusernameStatus.includes(1)) {

          setError({ ...error, message: "Task Already Exist..", status: 500 });
        }
        else{
          handelAddTaskByLead(formdata);
            
        }
      }
 
   fetchapi();
  }
  const onRemove=React.useCallback((selectedList, removedItem) => {
    // const newString = String(SelectedOption).replace(removedItem.value, "");
    const regex = new RegExp(removedItem.value, "g");
    const newString = String(option).replace(regex, "");
    const updatedItems = option.filter(item => item.value !== removedItem.value);
    setOption(updatedItems);
  },[option])
  return (
    <Form>
      <FormGroup>
        <Label>Task Title</Label>
        <Input
          type="text"
          value={task}
          name="task"
          onChange={(e) => setTask(e.target.value)}
        />
      </FormGroup>
      <FormGroup>
        <Label>Estimate Hours</Label>
        <Input type="number" name="" value={estimateHours} onChange={(e) => setEstimatedHours(e.target.value)}
        
        />
         
      </FormGroup>
      <FormGroup>
        <Label>Description</Label>
        <Input type="text" name="" value={description} onChange={(e) => setDescription(e.target.value)}
        
        />
         
      </FormGroup>
      <FormGroup>
        <Label>Due Date</Label>
        <Input type="date" value={moment(dueDate).format('YYYY-MM-DD')} onChange={(e) => setDueDate(e.target.value)} />
      </FormGroup>
      <FormGroup>
        <Label>Task Followers </Label>
        <Multiselect
         options={empoptions}
         onSelect={(e) => handleTaskFollowers(e[e.length-1].value)}
         displayValue="label"
         onRemove={onRemove}
        //  defaultValue={option}
         selectedValues={option}
        />
        {/* <SelectBoxSearch
          options={empoptions}
          onChange={(e) => handleTaskFollowers(e)}
          selectedUser={option}
 
        ></SelectBoxSearch> */}
      </FormGroup>
      <div className="text-center">
        <Button outline color="info" className="" onClick ={handelsubmit}>
          Submit
        </Button>
        <Button
          outline
          color="danger"
          className="ml-2"
          onClick={toggleAddEditFormClose}
        >
          Cancel
        </Button>
      </div>
      <Notifications notifications={error}></Notifications>
    </Form>
  );
};

export default AddEditForm;
